import React, { useEffect, useState } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import IntlMessages from "@util/IntlMessages";
import { getList } from "services/api/Api";
import { getUsersAvatars } from "services/restAPI/RestApi";
import "../SummaryWidget/summary.less";
import "./RankingStyle.less";
import RankingSettings from "../WidgetsSettings/HoppyRanking/RankingSettingsModal";
import defaultAvatar from "@assets/cp-hoppy/avatar40x40.png";
import puchar1 from "@assets/cp-hoppy/Puchar1.svg";
import puchar2 from "@assets/cp-hoppy/Puchar2.svg";
import puchar3 from "@assets/cp-hoppy/Puchar3.svg";
import { isActivePublicUser, isMultimodus } from "../../../util/Scripts";
import { Spin, Avatar, Divider } from "../../BP2Components";

const Ranking = ({ value, role, data }) => {
   const [columns, setColumns] = useState([]);
   const [visible, setVisible] = useState(false);
   useEffect(() => {
      if (value.columnToDisplayUser) {
         const foundAvatars = [];
         let usersWithAvatars = [];
         getList(value.listId, 1, value.itemsPerPage).then((res) => {
            const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
            responseData.data.map((user) => foundAvatars.push(user[value.columnToDisplayUser].id));
            responseData.data.sort(function (a, b) {
               return (
                  a[value.columnToDisplayPosition].value - b[value.columnToDisplayPosition].value ||
                  a[value.columnToDisplayUser].value.localeCompare(
                     b[value.columnToDisplayUser].value
                  )
               );
            });
            getUsersAvatars(foundAvatars).then((avatars) => {
               usersWithAvatars = responseData.data.map((t1) => ({
                  ...t1,
                  ...avatars.data.find((t2) => t1[value.columnToDisplayUser].id == t2.userOldId)
               }));
               setColumns(usersWithAvatars);
               setVisible(true);
            });
         });
      }
   }, [value]);

   const returnIconOrPosition = (position) => {
      switch (position) {
         case "1":
            return <img src={puchar1} alt="" />;
         case "2":
            return <img src={puchar2} alt="" />;
         case "3":
            return <img src={puchar3} alt="" />;
         default:
            return <div className="number-position">{position}</div>;
      }
   };
   const images = [
      {
         className: "icon icon-menu-up gx-text-primary gx-ml-1"
      },
      {
         className: "icon icon-menu-down gx-text-danger gx-ml-1"
      }
   ];
   return (
      <div className="summaryWidget hoppyRanking">
         <Widget
            styleName="gx-mt-3"
            bgColor={value.backgroundColourHex}
            className="summaryWidget"
            title={
               <h2 className={isMultimodus() ? "multimodus-header" : "header"}>
                  <IntlMessages id={value.rankingHeaderTranslationKey} />
               </h2>
            }
            role={role}
            extra={
               role === "OWNER" || role === "MODERATOR" ? (
                  <SettingsModal
                     widgetName={value.name}
                     widgetId={value.id}
                     icon="setting"
                     deleteIcon="true"
                     children={<RankingSettings value={value} columns={columns} data={data} />}
                  />
               ) : null
            }
         >
            <>
               {value.columnToDisplayUser ? (
                  visible ? (
                     <div className="gx-ml-2 gx-mr-2">
                        {columns &&
                           columns.map((user, i) => (
                              <>
                                 <div className="users-ranking gx-align-items-center ">
                                    <div className="user-display-fix gx-align-items-center">
                                       {returnIconOrPosition(
                                          user[value.columnToDisplayPosition].value
                                       )}
                                       <Avatar
                                          src={user.avatarUrl ? user.avatarUrl : defaultAvatar}
                                          className="gx-size-40 gx-ml-1"
                                       />
                                       <div className="user-name gx-font-weight-bold gx-ml-3">
                                          {user[value.columnToDisplayUser].value}
                                       </div>
                                    </div>
                                    <div className="gx-text-primary gx-font-weight-bold">
                                       {parseInt(user[value.columnToDisplayPoints])}
                                       <i
                                          className={
                                             i === 0
                                                ? images[0].className
                                                : images[Math.floor(Math.random() * 2)].className
                                          }
                                       />
                                    </div>
                                 </div>
                                 <Divider />
                              </>
                           ))}
                     </div>
                  ) : (
                     <Spin className="gx-ml-5" />
                  )
               ) : (
                  <p className="gx-pl-3">
                     <IntlMessages id="timeline.selectListIdAndAttributes" />
                  </p>
               )}
            </>
         </Widget>
      </div>
   );
};

export default Ranking;
